/* eslint-disable */
import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import queryString from 'query-string';

import { Box, Button, FormControl, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { DataGridPro, koKR, enUS, zhCN } from '@mui/x-data-grid-pro';

import { useEnumApi } from 'contexts/EnumApiContext';
import { BootstrapInput } from 'data/data';
import PageInfo from 'components/PageInfo';
import CustomEnumSelect from 'components/select/CustomEnumSelect';
import { getCompaniesByQuery, getCompaniesGroupCountByType } from 'components/axios/companyAxios';
import useConfig from 'hooks/useConfig';

const muiLocaleMap = {
  ko: koKR.components.MuiDataGrid.defaultProps.localeText,
  en: enUS.components.MuiDataGrid.defaultProps.localeText,
  'zh-CN': zhCN.components.MuiDataGrid.defaultProps.localeText,
};

const CompanyMonitoring = () => {
    const { getEnumValueByEnumName, getEnumValueByEnumNameAndCode } = useEnumApi();
    const { t, i18n } = useTranslation();
    const { mode } = useConfig();

    const navigate = useNavigate();
    const [searchField, setSearchField] = useState('name');
    const [searchKeyword, setSearchKeyword] = useState('');
    const [pageInfo, setPageInfo] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(process.env.REACT_APP_DEFAULT_PAGE_SIZE);

    // const [companyTypes, setCompanyTypes] = useState([]);
    // const [statuss, setStatuss] = useState([]);

    // useEffect(()=> {
    //   setCompanyTypes(getEnumValueByEnumName('CompanyType'))
    //   setStatuss(getEnumValueByEnumName('ActiveStatus'))
    // }, [])

    const [companies, setCompanies] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isParam, setIsParam] = useState(false);
    const [toggleStr, setToggleStr] = useState(true);
  
    const [companyType, setCompanyType] = useState('');
    const [companyStatus, setCompanyStatus] = useState('');
  
    const [sortModel, setSortModel] = useState(null);
  
    const searchFields = [{code:"name", title:t('message.common.subtitle.company.name')}, {code:"contact", title:t('message.common.subtitle.company.contact')}
      , {code:"managerName", title:t('message.common.subtitle.manager.name')}, {code:"email", title:t('message.common.subtitle.email')}
    ];
  
    let qs = queryString.parse(window.location.search);
    let companyTypeSelectColor = "";
    
    const [searchParam, setSearchParam] = useState({});
    const [searchParamString, setSearchParamString] = useState('');
  
    if (companyType === '' || companyType === "sum") {
      companyTypeSelectColor = " selected";
    }
    
    let columns = [
      { field: 'type', headerName: t('message.common.subtitle.companyType'), sortable:true, width: 120
        , renderCell:(params)=>(<Link to={'/company/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode('CompanyType', params.row?.type)?.[0]?.title}</Link>)
      },
      { field: 'name', headerName: t('message.common.subtitle.company.name'), sortable:true, width: 200
        , renderCell:(params)=>(<Link to={'/company/'+params.row?.id+searchParamString}>{params.row?.info.name}</Link>)
      },
      { field: 'address', headerName: t('message.common.subtitle.address'), sortable:true,  width: 250
        , renderCell:(params)=>(<Link to={'/company/'+params.row?.id+searchParamString}>{params.row?.info.address}</Link>)
      },
      { field: 'contact', headerName: t('message.common.subtitle.company.contact'), sortable:true,  width: 150
        , renderCell:(params)=>(<Link to={'/company/'+params.row?.id+searchParamString}>{params.row?.info.contact}</Link>)
      },
      { field: 'managerName', headerName: t('message.common.subtitle.manager.name'), sortable:true,  width: 150
        , renderCell:(params)=>(<Link to={'/company/'+params.row?.id+searchParamString}>{params.row?.users[0]?.name}</Link>)
      },
      { field: 'managerEmail', headerName: t('message.common.subtitle.email'), sortable:true, minWidth: 150
        , renderCell:(params)=>(<Link to={'/company/'+params.row?.id+searchParamString}>{params.row?.users[0]?.email}</Link>)
      },
      { field: 'status', headerName: t('message.common.subtitle.status'), sortable:true, width: 100
          , renderCell:(params)=>(<Link to={'/company/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode('ActiveStatus', params.row?.loginActiveStatus)?.[0]?.title}</Link>)
      }
    ];

    const handlePaging = (value) => {
      value = isNaN(value) ? 1 : value;
      setCurrentPage(value-1);
      setIsLoading(false);

      let searchParamCopy = {...searchParam};
      searchParamCopy.page = (value-1);
      setSearchParam(searchParamCopy);
    }

    useEffect(()=>{
      const searchOrders = searchParam.searchOrder;
      const searchParamCopy = {...searchParam};
      delete searchParamCopy.searchOrder;
      let searchString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
      if (searchOrders && searchOrders.length > 0) {
        let sortString = '';
        searchOrders.forEach(order=>sortString+="&sort="+order.sort)
        searchString += sortString;
      }
      setSearchParamString("?"+searchString)
    }, [searchParam])

    useEffect(()=>{
      const searchParamCopy = {...searchParam};
      let searchOrders = [];
      if (sortModel && sortModel.length > 0) {
        searchOrders.push({sort : sortModel[0].field+","+sortModel[0].sort});
      } else {
        searchOrders.push({sort : "info.name,asc"});
      }
      searchParamCopy.searchOrder = searchOrders;
      setSearchParam(searchParamCopy)
    },[sortModel])
  
    useEffect(()=> {
      if (qs) {
        if (qs.page && qs.page !== (currentPage)) {setCurrentPage(qs.page);}
        if (qs.size) setPageSize(qs.size);
        if (qs.searchField) setSearchField(qs.searchField);
        if (qs.searchKeyword) setSearchKeyword(qs.searchKeyword);
        if (qs.searchType) setCompanyType(qs.searchType);
        if (qs.searchStatus) setCompanyStatus(qs.searchStatus);

        let searchParamCopy = {...searchParam};
        if (qs.page && qs.page !== (currentPage)) {searchParamCopy.page = qs.page};
        if (qs.size) {searchParamCopy.size = qs.size} ;
        if (qs.searchField) {searchParamCopy.searchField = qs.searchField};
        if (qs.searchKeyword) {searchParamCopy.searchKeyword = qs.searchKeyword};
        if (qs.searchStatus) {searchParamCopy.searchStatus = qs.searchStatus};
        if (qs.searchType) {searchParamCopy.searchType = qs.searchType};
        if (qs.sort && qs.sort.length > 0) {
          let orders = [];
          let sortModel = [];
          if (!Array.isArray(qs.sort)) {
            orders.push({sort:qs.sort});
            sortModel.push({"field": qs.sort.split(',')[0],"sort": qs.sort.split(',')[1]})
          } else {
            (qs.sort).forEach(order=>orders.push({sort:order}));
            qs.map(order=>sortModel.push({"field": order.sort.split(',')[0],"sort": order.sort.split(',')[1]}))
          }
          setSortModel(sortModel)
          searchParamCopy.searchOrder = orders;
        } else {
          delete searchParamCopy.searchOrder
        };
        setSearchParam(searchParamCopy);
      }
      setIsParam(true);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [qs.page, qs.size, qs.searchField, qs.searchKeyword, qs.searchStatus, qs.searchType]);
    
    // 목록
    useEffect(()=> {
      if ((!isLoading || sortModel != null) && !isNaN(currentPage) && isParam && getEnumValueByEnumName("CompanyType")) {
        companyList();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, isLoading, pageSize, companyType, isParam, sortModel, getEnumValueByEnumName("CompanyType")]);

    useEffect(()=> {
      companyList();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n.language, getEnumValueByEnumName("CompanyType")]);

    const [companyTypeGroupCounts, setCompanyTypeGroupCounts] = useState([]);
    const [totalCompanyTypeGroupCount, setTotalCompanyGroupCount] = useState(0);
  
    const companyList = (curPage=currentPage) => {
      isNaN(curPage) && setCurrentPage(0);
      isNaN(pageSize) && setPageSize(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
      setCurrentPage(curPage)
  
      let param = {
        page : curPage,
        size : pageSize,
      };
      let countParam = {...param};
      if (companyStatus) {
        param.loginActiveStatus = companyStatus;
      }
      if (companyType !== 'sum')
        param.type = companyType;

      let keyword = searchKeyword;
      if (searchKeyword) {
          if (!searchField) {
            setSearchField('name')
            keyword = 'contains('+searchKeyword+')';
            param["info.name"] = keyword;
          } else {
            if (searchField && (searchField === 'name' || searchField === 'managerName')) {
              keyword = 'contains('+searchKeyword+')';
            }

            if (searchField === 'name') {
              param["info.name"] = keyword;
            } else if (searchField === 'managerName') {
              param["users.name"] = keyword;
            } else if (searchField === 'contact') {
              param["info.contact"] = keyword;
            } else if (searchField === 'email') {
              param["users.email"] = keyword;
            }
          }
      }

      if (sortModel && sortModel.length > 0)
        param.sort = sortModel[0].field+","+sortModel[0].sort;
      else
        param.sort = "info.name,asc";

      Promise.all([
        getCompaniesByQuery(param).then((data)=>{
          if (data != null) {
            setPageInfo(data.page);
            if(data._embedded) {
              setCompanies(data._embedded.companies);
            } else {
              setCurrentPage(0);
              setCompanies([]);
            }
          } else {
            pageInfo = {
              size : pageInfo.size,
              totalElements : 0,
              totalPages : 0,
              number : 0
            }
            setPageInfo(pageInfo);
            setCompanies([]);
          }
        }),
        getCompaniesGroupCountByType(countParam).then((res)=>{
          return res;
        })
      ]).then((res)=>{
        if (res != null && res[1] != null) {
          let companyTypeGroupCounts = [];
          let totalCompanyGroupCount = 0;
          // console.log(res[1])
          const companyTypes = getEnumValueByEnumName("CompanyType");
            // console.log(companyTypes)
          if (res[1] != null && companyTypes != null) {
            // console.log(res[1])
            let isInclude = false;
            companyTypes?.map(function(item1) {
              // console.log(item1)
              isInclude = false;
              res[1].map(function(item2) {
              // console.log(item2)
                if (item2.groups.includes(item1.code)) {
                  companyTypeGroupCounts.push(...[{
                    name : item1.code,
                    id : item1.code,
                    title : item1.title,
                    count : item2.count,
                  }]);
                  totalCompanyGroupCount += item2.count;
                  isInclude = true;
                }
              })

              if (!isInclude) {
                let defaultStatus = [{
                  name : item1.code,
                  id : item1.code,
                  title : item1.title,
                  count : 0,
                }];
                companyTypeGroupCounts.push(...defaultStatus);
              }
            })
            setCompanyTypeGroupCounts(companyTypeGroupCounts);
            setTotalCompanyGroupCount(totalCompanyGroupCount);
          } else {
            setCompanyTypeGroupCounts([]);
            setTotalCompanyGroupCount(0);
          }
        }
      })
      
      setIsLoading(true);
    }
   
    const handleInput = (event) => {
      event.preventDefault();
      setSearchKeyword(event.target.value.trim());
    };
  
    const handleOnKeyPress = e => {
      if (e.key === 'Enter') {
        handleSearch(e); // Enter 입력이 되면 클릭 이벤트 실행
      }
    };
 
    const handleSearch = (event) => {
      event.preventDefault();
      setCurrentPage(0);
      pageInfo.number = 0;
      setPageInfo(pageInfo);
      companyList(0);

      let searchParamCopy = {...searchParam};
      searchParamCopy.page = 0;
      if (pageSize) {searchParamCopy.size = pageSize};
      if (searchField) {searchParamCopy.searchField = searchField};
      if (searchKeyword) {searchParamCopy.searchKeyword = searchKeyword};
      if (companyStatus) {searchParamCopy.searchStatus = companyStatus};
      if (companyType) {searchParamCopy.searchType = companyType};
      setSearchParam(searchParamCopy)
      const paramString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
      navigate("?"+paramString)
    };

    const handleMobileOnKeyPress = e => {
      if (e.key === 'Enter') {
        handleMobileSearch(e); // Enter 입력이 되면 클릭 이벤트 실행
      }
    };

    const handleMobileSearch = (event) => {
      handleSearch(event);
      handleClose();
    };
  
    const statusTapSearch = (vCode) => {
      // console.log(vCode)
      setCurrentPage(0);
      pageInfo.number = 0;
      setPageInfo(pageInfo);
      setCompanyType(vCode);
      initSearch();

      let searchParamCopy = {...searchParam};
      searchParamCopy.page = 0;
      if (pageSize) {searchParamCopy.size = pageSize};
      if (searchField) {searchParamCopy.searchField = searchField};
      searchParamCopy.searchType = vCode;
      searchParamCopy.searchStatus = '';
      searchParamCopy.searchField = '';
      searchParamCopy.searchKeyword = '';
      setSearchParam(searchParamCopy)
      const paramString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
      navigate("?"+paramString)
    };
  
    const initSearch = ()  => {
      setCompanyStatus('');
      setToggleStr(!toggleStr);
      setSearchField('name');
      setSearchKeyword('');
      setCurrentPage(0);
      setIsLoading(false);
    };

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
      setOpen(true);
    };

    const handleClose = (event, reason) => {
      if (reason !== 'backdropClick') {
        setOpen(false);
      }
    };
  
    // if (isLoading) {
    return (
      <div className="sub_container">
        <div className='search_section'>
          <ul className='condition' style={{marginTop:"px"}}>
            <li>{t('message.common.subtitle.companyType')}</li>
            <li className={`sum${companyTypeSelectColor}`} onClick={() => statusTapSearch('sum')} style={{cursor:"pointer"}}>{t('message.common.total')}: {totalCompanyTypeGroupCount}</li>
            {companyTypeGroupCounts &&
              companyTypeGroupCounts.map(function(item, i) {
                companyTypeSelectColor = "";
                if (item.id === companyType) {
                  companyTypeSelectColor = " selected";
                }
                let addTitle = '';
                return (
                  <li key={i} className={`${item.id}${companyTypeSelectColor}`} onClick={() => statusTapSearch(item.id)} style={{cursor:"pointer"}}>{addTitle == '' && item.title}{addTitle}: {item.count}</li>      
                )
              }) }
          </ul>
          
          <div className='selectbox'>
            <div className="desktop_serach">
              <Box component="form">
                <div>
                  <div>
                    <div style={{display:"inline-block"}}>
                      <FormControl sx={{ m: 1, minWidth: 80 }}>
                        <CustomEnumSelect
                          key={companyStatus}
                          label={t('message.common.subtitle.status')}
                          labelName={t('message.common.subtitle.status')}
                          name={'searchStatus'}
                          defaultValue={companyStatus}
                          onChange={(e)=>{
                            setCompanyStatus(e.target.value);
                          }}
                          list={getEnumValueByEnumName('ActiveStatus')}
                      />
                      </FormControl>
                      {searchFields && 
                      <FormControl sx={{ m: 1, minWidth: 80 }}>
                        <CustomEnumSelect
                          key={searchField}
                          label={t('message.common.btn.search')}
                          labelName={t('message.common.btn.search')}
                          name={'searchField'}
                          defaultValue={searchField}
                          onChange={(e)=>{
                            setSearchField(e.target.value);
                          }}
                          list={searchFields}
                      />
                      </FormControl>
                      }
                      <FormControl sx={{ m: 1 }} variant="standard">
                        <BootstrapInput id="demo-customized-textbox" className='search_11' style={{ width : "130px" }} value={searchKeyword || ''} onChange={handleInput} onKeyPress={handleOnKeyPress}/>
                      </FormControl>
    
                      <Button className='search_icon1' variant="contained" style={{marginTop:"0",padding:"12px 15px"}} onClick={handleSearch}>
                        <span className="icon_png"><img src={`${process.env.PUBLIC_URL}/img/icon/search.png`} alt='' /></span>{t('message.common.btn.search')}
                      </Button>
                    </div>
                  </div>
                </div>
              </Box>
            </div>

            <div className="mobile_serach" style={{display:"none"}}>
              <Button style={{width:"100%",marginBottom:"10px"}} variant="contained" color="secondary" onClick={handleClickOpen}>
                {t('message.common.text.search.category.open')}
              </Button>
              <Dialog className="mobile_serach_box" disableEscapeKeyDown open={open} onClose={handleClose}>
                <DialogTitle>{t('message.common.text.search.category.select')}</DialogTitle>
                <DialogContent>
                    <Box component="form">
                      <div>
                        <div>
                          <div style={{display:"inline-block"}}>
                            <FormControl sx={{ m: 1, minWidth: 80 }}>
                              <CustomEnumSelect
                                key={companyStatus}
                                label={t('message.common.subtitle.status')}
                                labelName={t('message.common.subtitle.status')}
                                name={'searchStatus'}
                                defaultValue={companyStatus}
                                onChange={(e)=>{
                                  setCompanyStatus(e.target.value);
                                }}
                                list={getEnumValueByEnumName('ActiveStatus')}
                            />
                            </FormControl>
                            {searchFields && 
                            <FormControl sx={{ m: 1, minWidth: 80 }}>
                              <CustomEnumSelect
                                key={searchField}
                                label={t('message.common.btn.search')}
                                labelName={t('message.common.btn.search')}
                                name={'searchField'}
                                defaultValue={searchField}
                                onChange={(e)=>{
                                  setSearchField(e.target.value);
                                }}
                                list={searchFields}
                            />
                            </FormControl>
                            }
                            <FormControl sx={{ m: 1 }} variant="standard">
                              <BootstrapInput id="demo-customized-textbox" style={{ width : "130px" }} value={searchKeyword} onChange={handleInput} onKeyPress={handleMobileOnKeyPress}/>
                            </FormControl>
                          </div>
                        </div>
                      </div>
                    </Box>
                    </DialogContent>
                  <DialogActions>
                    <Button onClick={handleMobileSearch} variant="contained">{t('message.common.btn.search')}</Button>
                    <Button onClick={handleClose} variant="contained" color="secondary">{t('message.common.btn.cancel')}</Button>
                  </DialogActions>
                </Dialog>
            </div>
          </div>
        </div>

        <Box 
          id="tableDiv"
          sx={{
            mt: 3,
            padding: "20px",
            borderRadius: "20px",
            overflow: "hidden",
            background: `${mode === 'dark' ? "#182131": "#fff"}`,
            border: `${mode === 'dark' ? "1px solid rgba(255,255,255,0.06)": "1px solid #30363d"}`,
            boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
          }}
        >
          <DataGridPro
            rows={companies && companies !== undefined ? companies : []}
            columns={columns}
            disableColumnFilter
            sortModel={sortModel || []}
            onSortModelChange={setSortModel}
            localeText={muiLocaleMap[i18n.language] ?? enUS.components.MuiDataGrid.defaultProps.localeText}
            sx={{
              "& .MuiDataGrid-footerContainer, & .MuiDataGrid-toolbarContainer": {
                display: "none",
              },
              "& .MuiDataGrid-cell.statusReport" : {overflow:"unset !important"}
            }}
          />
        </Box>

        {/* <div className="btn_right">
            <Link to={'./add'+searchParamString}><Button variant="contained" color="primary">{t('message.common.title.company.write')}</Button></Link>
        </div> */}
        
        <PageInfo pageInfo={pageInfo} handlePaging={handlePaging}/>
          
      </div>
    );
  // }
}

export default CompanyMonitoring;